import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "startpage-cases",
  class: "py-4"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Uppdaterad:", -1)
const _hoisted_8 = { class: "justify-self-end pe-5" }
const _hoisted_9 = { class: "pt-4" }


import { useCaseStore } from '@/stores/caseStore'
import router from '@/router'
import customButton from '@/components/ui/custom-button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'startpageCases',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  }
},
  setup(__props) {

const CaseStore = useCaseStore()

const props = __props

function setCaseID (item: any) {
  CaseStore.setCaseID(item.friendlyCaseID)
  router.push({ path: `/case/${item.friendlyCaseID}` })
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", {
      class: _normalizeClass(__props.textClass?.h2)
    }, "Händelser i mina ärenden", 2),
    _createElementVNode("div", _hoisted_1, [
      (_unref(CaseStore).caseLoadStatus === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Det uppstod ett fel när vi hämtade din informationen, vänligen försök igen senare. "))
        : (_unref(CaseStore).caseLoadStatus !== 'loaded' &&
    _unref(CaseStore).caseLoadStatus !== 'loadedWithErrors')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "18"
              }),
              _createTextVNode(" Laddar in senaste händelserna... ")
            ]))
          : (_unref(CaseStore).caseLoadStatus === 'loaded' &&
    _unref(CaseStore).getChosenCaseList.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Det finns inga händelser i dina ärenden, eller så har vi inte hittat några ärenden. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CaseStore).getStartpageSubset, (item) => {
                  return (_openBlock(), _createBlock(_component_v_hover, {
                    key: item.friendlyCaseID
                  }, {
                    default: _withCtx(({ isHovering, props }) => [
                      _createVNode(_component_v_card, _mergeProps({
                        flat: "",
                        class: { 'on-hover': isHovering },
                        style: {
    '--v-hover-opacity': isHovering ? '0.025' : '0',
    'max-width': '750px',
  }
                      }, props, {
                        onClick: ($event: any) => (setCaseID(item))
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_item, { class: "py-2 px-0" }, {
                            append: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_v_icon, {
                                  color: "primary",
                                  icon: "mdi-arrow-right"
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, { class: "pa-0 ma-0 d-flex justify-even-spaceing" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, _toDisplayString(item.description), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_card_text, { class: "pa-0 ma-0" }, {
                                default: _withCtx(() => [
                                  _hoisted_6,
                                  _createTextVNode(" " + _toDisplayString(item.status), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_card_text, { class: "pa-0 ma-0" }, {
                                default: _withCtx(() => [
                                  _hoisted_7,
                                  _createTextVNode(" " + _toDisplayString(item.updated), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1040, ["class", "style", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(customButton, {
                    text: 'Alla Ärenden & tjänster',
                    href: '/case',
                    "ref-type": 'internalRoute'
                  })
                ])
              ]))
    ])
  ], 64))
}
}

})